import React from 'react'
import { ApolloProvider } from 'react-apollo'
import { client } from '../shared/ApolloClient'
import PropTypes from 'prop-types'

import SectionResolver from './SectionResolver'

const MainWrapper = props => (
  <ApolloProvider client={client}>
    <SectionResolver {...props} />
  </ApolloProvider>
)

MainWrapper.propTypes = {
  loanId: PropTypes.number.isRequired,
  customerService: PropTypes.bool,
  section: PropTypes.string.isRequired
}

export default MainWrapper
